import { GoLocation } from "react-icons/go";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import CardForItemCompact from "../../../applicationUI/CardForItemCompact";
import accountTypes from "../../../../data/accountTypes";
import goTo from "../../../../controllers/goTo";
import { LuBox } from "react-icons/lu";
import MessageBox from "../../../helperComponents/MessageBox";
import styled from "styled-components";
import ReportActionButton from "../report/ReportActionButton";

const ReportSectionButtons = styled.div``;

export default function ProfileCard({ data, onCardClick, forReportPurposes }) {
  if (!onCardClick) onCardClick = goTo(`/u/${data.username}`);

  if (data.isBanned) {
    return <MessageBox>This profile is banned</MessageBox>;
  }

  let attachedComponent = null;

  if (forReportPurposes) {
    attachedComponent = (
      <ReportSectionButtons>
        <ReportActionButton action="BAN" itemId={data._id} itemType="CONTENT" />

        <ReportActionButton
          action="IGNORE"
          itemId={data._id}
          itemType="CONTENT"
        />
      </ReportSectionButtons>
    );
  }

  return (
    <CardForItemCompact
      attachedComponent={attachedComponent}
      data={data}
      onCardClick={() => {
        onCardClick(data);
      }}
      isProfile={true}
      image={data.profileImage}
      itemType={"PROFILE"}
      itemId={data._id}
      title={`${data.name}`}
      line1={
        data.bio && [
          {
            text: `${data.bio}`,
          },
        ]
      }
      line2={[
        data.state && {
          icon: <GoLocation />,
          text: `${data.state}`,
        },
        data.city && {
          icon: <GoLocation />,
          text: `${data.city}`,
        },
        {
          icon: <LuBox />,
          text: `${
            parseDropDownValue({
              query: data.accountType,
              theArray: accountTypes,
            }) || "NA"
          }`,
        },
      ]}
    />
  );
}
